import { Box, Checkbox, Grid, IconButton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  Document,
  Groups,
  GroupSignatories,
  individuals_Poa_nonIndividuals_Documents,
} from '../../redux-store/types/api-types';
import { MobileViewDataRow } from '../DataTable';
import { getASDocuments, viewDownloadCell } from '../NonIndividualInvestor/Authorised';
import { documentDetails } from '../investors/documentDetails';
import { Item } from '../ApplicationDetails';
import { useDispatch } from 'react-redux';
import { getDocuments } from '../../redux-store/actions/application';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { AccessibleDialog } from '../../lib/AccessibleDialog';
const baseHeaders = [
  {
    header: 'Name',
    label: 'name',
    valueGetter: (row: GroupSignatories) => row.name || 'N/A',
  },
  {
    header: 'PAN',
    valueGetter: (row: GroupSignatories) => row.pan.toUpperCase() || 'N/A',
  },
  {
    header: 'Email ID',
    valueGetter: (row: GroupSignatories) => row.email || 'N/A',
  },
  {
    header: 'Designation',
    valueGetter: (row: GroupSignatories) => row.designation || 'N/A',
  },
  {
    header: 'Address Line 1',
    label: 'address1',
    valueGetter: (row: GroupSignatories) => row?.address1 || 'N/A',
    showForICICIOnly: true,
  },
  {
    header: 'Address Line 2',
    label: 'address2',
    valueGetter: (row: GroupSignatories) => row?.address2 || 'N/A',
    showForICICIOnly: true,
  },
  {
    header: 'Country',
    label: 'country',
    valueGetter: (row: GroupSignatories) => row?.country || 'N/A',
    showForICICIOnly: true,
  },
  {
    header: 'State',
    label: 'state',
    valueGetter: (row: GroupSignatories) => row?.state || 'N/A',
    showForICICIOnly: true,
  },
  {
    header: 'City',
    label: 'city',
    valueGetter: (row: GroupSignatories) => row?.city || 'N/A',
    showForICICIOnly: true,
  },
  {
    header: 'Pincode',
    label: 'pincode',
    valueGetter: (row: GroupSignatories) => row?.pincode || 'N/A',
    showForICICIOnly: true,
  },
  {
    header: 'Mobile Number',
    valueGetter: (row: GroupSignatories) =>
      row.mobile && row.countryCode ? row.countryCode + '-' + row.mobile : row.mobile || 'N/A',
  },
  {
    header: 'Politically Exposed Person (PEP) Status',
    valueGetter: (row: GroupSignatories) => row.politicallyExposedPersonStatus || 'N/A',
  },
];
const aadharHeader = {
  header: 'Aadhar Last 4 Digit',
  valueGetter: (row: GroupSignatories) =>
    row?.designation?.toLowerCase() === 'karta' ? row.aadharNumber || 'N/A' : 'N/A',
};
const sendToEsignCell = {
  header: (): JSX.Element => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };
    return (
      <>
        <Typography
          variant="h6"
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontSize: 14,
            fontWeight: 500,
            color: 'primary.main',
            pr: 0.5,
          }}
          component="span">
          Send e-sign link
        </Typography>
        <InfoOutlinedIcon
          color="info"
          fontSize="small"
          onClick={handleOpen}
          sx={{ position: 'relative', top: 4 }}
        />

        <AccessibleDialog
          onClose={handleClose}
          open={open}
          sx={{
            '.MuiPaper-root ': {
              maxWidth: 400,
              p: { xs: 2, sm: '15px 20px 45px' },
              borderRadius: '10px',
              height: 'unset',
              overflowY: 'auto',
            },
          }}>
          <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end' }}>
            <CloseIcon fontSize="medium" />
          </IconButton>
          <Box sx={{ mb: 2, textAlign: 'center', '.MuiSvgIcon-root': { fontSize: '3.1875rem' } }}>
            <InfoOutlinedIcon color="info" fontSize="large" />
          </Box>
          <Box
            sx={{
              width: { xs: '100%', sm: '80%' },
              mx: 'auto',
              '.MuiTypography-root': {
                fontSize: 20,
                fontWeight: 500,
                textAlign: 'center',
              },
            }}>
            <Typography component="h3" sx={{ color: 'secondary.main', lineHeight: '35px' }}>
              Use this option to send the e-sign link to specific set of authorized signatories.
            </Typography>
          </Box>
        </AccessibleDialog>
      </>
    );
  },
  renderEditDeleteCell: (row: GroupSignatories): JSX.Element => {
    return (
      <Checkbox
        checked={row.canEsign}
        sx={{ display: { xs: 'block' }, ':hover': { backgroundColor: 'white' } }}
        disabled
      />
    );
  },
};
export default function AuthorizedSignatories({ groups = [] }: { groups: Groups[] }): JSX.Element {
  const [groupSignatoriesDocData, setGroupSignatoriesDocData] = useState<documentDetails[]>([]);
  const [authorisedSignatoriesGroup, setAuthorisedSignatoriesGroup] = useState<Groups[]>([]);

  const dispatch = useDispatch();
  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(getDocuments())) as unknown as Document;
        const groupSignatoryData = (
          (response?.non_individual_autherized_signatory as unknown as individuals_Poa_nonIndividuals_Documents[]) ||
          []
        ).map((_doc) => {
          return { ..._doc, documentId: '', isActive: true };
        });
        setGroupSignatoriesDocData(groupSignatoryData);
        const authorzedSignatoryObj = groups.length
          ? groups.map((group) => {
              return {
                ...group,
                groupsignatories: group.groupsignatories.map((signatory) => {
                  return {
                    ...signatory,
                    groupsignatorydocuments: getASDocuments(response, signatory, false), //3rd argument is used for documents mandatory check as that mandatory logic is not required here so passing false by default
                  };
                }),
              };
            })
          : groups;
        setAuthorisedSignatoriesGroup(authorzedSignatoryObj);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography
              component="h2"
              sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
              Authorized Signatories
            </Typography>
            {authorisedSignatoriesGroup.length === 0 && (
              <Grid
                xs={12}
                sm={12}
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: 'common.black',
                  textAlign: 'center',
                  my: 3,
                }}>
                No Authorized Signatories
              </Grid>
            )}
            {authorisedSignatoriesGroup.map((group, index) => {
              const hasKarta = group.groupsignatories.some(
                (s) => s?.designation?.toLowerCase() === 'karta'
              );
              const tableHeaderForGroup = [
                sendToEsignCell,
                ...baseHeaders,
                ...(hasKarta ? [aadharHeader] : []),
                ...viewDownloadCell(groupSignatoriesDocData),
              ];
              return (
                <React.Fragment key={group.id}>
                  <Grid container pt={3}>
                    <Typography component="h2">
                      Total No. of required authorized signatories : {group.threshold}
                    </Typography>
                  </Grid>
                  <Grid container pt={2}>
                    <Grid xs={12} alignSelf="center">
                      {group.groupsignatories
                        .filter((_signatory) => _signatory.isActive)
                        .map((signatory, signatoryIndex) => (
                          <React.Fragment key={signatory.id}>
                            <Item
                              sx={{
                                marginBottom: '20px',
                                paddingLeft: { xs: '10px', sm: '30px' },
                              }}>{`Authorized Signatory ${signatoryIndex + 1}`}</Item>
                            <MobileViewDataRow
                              index={signatoryIndex}
                              groupIndex={index}
                              row={signatory}
                              tableHeader={tableHeaderForGroup}
                            />
                          </React.Fragment>
                        ))}
                    </Grid>
                  </Grid>
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
